/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {UserEntityBaseModel} from './user-entity-base.model';
import {UserEntityBaseContract} from '../../../../api/ms-security/contracts/user-entity-base.contract';


export class UserEntityBaseMapper {

    static fromUserEntityBaseContractArray(input: UserEntityBaseContract[]): UserEntityBaseModel[] {
        return input?.map(UserEntityBaseMapper.fromUserEntityBaseContract);
    }

    static fromUserEntityBaseContract(input: UserEntityBaseContract): UserEntityBaseModel {
        let output: UserEntityBaseModel;
        if (input != null) {
            output = {...input};
        }
        return output;
    }
}
